/**
 * Normalises the global search box into the filters already supported by the
 * public trips endpoint.  A query such as "Praia em Portugal" becomes
 * text="Praia" and country="Portugal", while all other text stays intact.
 */
export function parseGlobalSearchQuery(value) {
  const raw = String(value || '').replace(/\s+/g, ' ').trim();
  if (!raw) return { raw: '', text: '', country: '' };

  const match = raw.match(/^(.+?)\s+em\s+(.+)$/i);
  if (!match) return { raw, text: raw, country: '' };

  const text = match[1].trim();
  const country = match[2]
    .trim()
    .replace(/^[,;:\-\s]+|[,;:\-\s]+$/g, '');

  return {
    raw,
    text: text || raw,
    country,
  };
}

export default parseGlobalSearchQuery;
